/**
 * Les marques des services qu'on branche, dessinées en SVG.
 *
 * Deux boutons « Connecter » portant la même enveloppe grise ne se
 * distinguent que par leur texte : on lit avant de reconnaître, alors que ces
 * logos-là se reconnaissent sans lire. Ils sont tracés ici plutôt que chargés
 * d'un fichier pour qu'ils suivent la taille demandée et ne dépendent d'aucun
 * réseau, sur un écran qui sert justement à réparer une connexion.
 *
 * Ce sont des marques déposées de leurs éditeurs, utilisées pour désigner le
 * service qu'elles nomment, et rien d'autre.
 */

interface MarkProps {
  size?: number;
  className?: string;
}

/** Gmail : l'enveloppe blanche et le M en quatre couleurs. */
export function GmailMark({ size = 18, className = '' }: MarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path fill="#fff" d="M6 12h36v24H6z" />
      <path fill="#EA4335" d="M6 12l18 13L42 12v4L24 29 6 16z" />
      <path fill="#FBBC05" d="M6 12H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h2z" />
      <path fill="#34A853" d="M42 12h2a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-2z" />
      <path fill="#4285F4" d="M6 36V16l18 13 18-13v20z" opacity=".9" />
    </svg>
  );
}

/** Outlook : le carré bleu et le O blanc. */
export function OutlookMark({ size = 18, className = '' }: MarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" className={className} aria-hidden="true">
      <rect x="4" y="10" width="26" height="28" rx="3" fill="#0364B8" />
      <ellipse cx="17" cy="24" rx="7.5" ry="8.5" fill="#fff" />
      <ellipse cx="17" cy="24" rx="4" ry="5" fill="#0364B8" />
      <path fill="#28A8EA" d="M30 15h14v18a2 2 0 0 1-2 2H30z" />
      <path fill="#0078D4" d="M30 15h14v4l-7 5-7-5z" />
    </svg>
  );
}
